import styled from 'styled-components'
import { sizeMobile, sizeMedium } from 'components/globalStyles'
import { GridMixin } from 'components/common/common_styles'
import { fontClamp } from 'utils/textUtils'
import { StyledP } from 'components/common/typography'

export const QuoteContainer = styled.div`
  ${GridMixin};
  max-width: 67%;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  row-gap: 24px;

  @media (max-width: ${sizeMedium}) {
    max-width: 90%;
  }

  @media (max-width: ${sizeMobile}) {
    grid-template-columns: auto;
    grid-template-rows: repeat(3, auto);
    max-width: none;
  }
`

export const QuoteText = styled.p`
  font-family: Garamond;
  font-size: ${fontClamp(3.2, 3.6)};
  line-height: 1.15em;
  align-self: end;
`

export const QuoteAttribution = styled(StyledP)`
  color: #333333;
`

export const QuoteImage = styled.img`
  grid-row: 1 / span 2;
  max-height: 250px;

  @media (max-width: ${sizeMobile}) {
    grid-row: 1;
    justify-self: center;
  }
`
